import {StateType} from "./store/store";


export const portfolioSelecror = (state:StateType) => state.main.portfolio
export const menuModeSelecror = (state:StateType) => state.main.menuMode
export const skillsSelecror = (state:StateType) => state.main.skills
export const activeLinkSelecror = (state:StateType) => state.main.activeLink